<template>
    <div class="auto-section">
        <div class="auto-content">
            <h2 class="auto-title fuente-posm">
                ¿El personal se auto califica?
            </h2>
            <p class="auto-text fuente-nova">
                Nuestras encuestas son validadas por número de WhatsApp
                <br><br>
                Al responder una encuesta más de una vez, detectamos el número sospechoso y enviamos una notificación de actividad inusual a tu equipo.
            </p>
        </div>
        <div class="auto-image">
            <img :src="a59" alt="Auto califica">
        </div>
    </div>
</template>

<script>
export default {
    name: 'AutoCalificaFeedbackNew',
    data() {
        return {
            a59: require('@/assets/images/a59.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.auto-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.auto-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.auto-image img {
    width: 300px;
    height: auto;
}

.auto-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.auto-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.auto-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .auto-title {
        font-size: 60px;
    }

    .auto-text {
        font-size: 27px;
    }

    .auto-image img {
        width: 250px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .auto-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .auto-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .auto-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .auto-image img {
        width: 50%;
        max-width: 200px;
    }

    .auto-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .auto-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
